import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js';

u.use(UIBootstrap5);

export default u;

// toggle mobile button icon change
const mobileToggler = document.querySelector<HTMLElement>('.j-header-toggler');
const mobileOffcanvas = document.querySelector<HTMLElement>('.j-navbar-offcanvas');

mobileOffcanvas?.addEventListener('show.bs.offcanvas', (event) => {
  if (mobileToggler) {
    mobileToggler.classList.remove('navbar-toggler-icon');
    mobileToggler.classList.add('btn', 'btn-close');
  }
});
mobileOffcanvas?.addEventListener('hidden.bs.offcanvas', (event) => {
  if (mobileToggler) {
    mobileToggler.classList.remove('btn', 'btn-close');
    mobileToggler.classList.add('navbar-toggler-icon');
  }
});

const buyNowBtn = document.querySelector('.j-buy-now-btn')! as HTMLButtonElement;
const buyNowBlock = document.querySelector('.j-buy-now')! as HTMLDivElement;

buyNowBtn.addEventListener('click', function (e) {
  if (window.innerWidth > 1200) {
    return;
  }

  if (buyNowBlock.classList.contains('active')) {
    buyNowBlock.classList.remove('active');
  } else {
    buyNowBlock.classList.add('active');
  }

  e.stopPropagation();
});

document.body.addEventListener('click', function (event) {
  if (buyNowBlock.classList.contains('active')) {
    buyNowBlock.classList.remove('active');
  }
});
